import {
  CLEAR_STATE,
  SET_DOOR,
  SET_EVENT,
  SET_PANIER, SET_PANIER_REFERENCE,
  SET_PRODUCT_TO_SHOW,
  SET_SELECTED_CARD,
  SET_SELECTED_PDV,
  SET_STADIUM, SET_TIME_CREATION_PANIER,
  SET_USER
} from './types';
import {OrderModel} from "../../Models/OrderModel";
import {DoorModel} from "../../Models/DoorModel";
import {ProductModel} from "../../Models/ProductModel";
import {StadiumModel} from "../../Models/StadiumModel";
import {EventModel} from "../../Models/EventModel";
import {UserModel} from "../../Models/UserModel";
import {CarteBancaireModel} from "../../Models/CarteBancaireModel";

export const clearState = () => {
  return {
    type: CLEAR_STATE,
  };
};

export const setUser = (snapshot: UserModel | undefined) => {
  return {
    type: SET_USER,
    snapshot,
  };
};

export const setStadium = (snapshot: StadiumModel) => {
  return {
    type: SET_STADIUM,
    snapshot,
  };
};

export const setPanier = (snapshot: OrderModel | undefined) => {
  return {
    type: SET_PANIER,
    snapshot,
  };
};

export const setPanierReference = (snapshot: string) => {
  return {
    type: SET_PANIER_REFERENCE,
    snapshot,
  };
};

export const setDoor = (snapshot: DoorModel | undefined) => {
  return {
    type: SET_DOOR,
    snapshot,
  };
};

export const setProductToShow = (snapshot: ProductModel | undefined) => {
  return {
    type: SET_PRODUCT_TO_SHOW,
    snapshot,
  };
};

export const setSelectedPdv = (snapshot: number | undefined) => {
  return {
    type: SET_SELECTED_PDV,
    snapshot,
  };
};

export const setEvent = (snapshot: EventModel | undefined) => {
  return {
    type: SET_EVENT,
    snapshot,
  };
};

export const setSelectedCard = (snapshot: CarteBancaireModel | undefined) => {
  return {
    type: SET_SELECTED_CARD,
    snapshot,
  };
};

export const setTimeCreationPanier= (snapshot: number | undefined) => {
  return {
    type: SET_TIME_CREATION_PANIER,
    snapshot,
  };
};
